import { css, FlattenInterpolation, ThemeProps } from 'styled-components';
import { ifProp } from 'styled-tools';

import LoaderContainer from '../../Loader/styled/LoaderContainer';
import StyledButtonContent from '../styled/StyledButtonContent';
import { ButtonPropsWithTheme } from '../types';
import { GlobalThemeType } from '../../../themes/types';

import buttonSize from './buttonSize';
import buttonColor from './buttonColor';
import disabledStyle from './disabledStyle';

const buttonStyle = (
  props: ButtonPropsWithTheme,
): FlattenInterpolation<ThemeProps<GlobalThemeType>> =>
  css`
    display: ${props.display || 'inline-block'};
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
    -webkit-appearance: none;
    outline: 0;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
    position: relative;
    transition: background 0.33s ease, color 0.33s ease, border 0.33s ease;
    margin: 0;

    &:hover,
    &:active,
    &:focus {
      outline: 0;
      text-decoration: none;
    }

    ${buttonSize(props)}
    ${buttonColor(props)}
  ${disabledStyle(props)}

  ${LoaderContainer} {
      position: absolute;
      top: 50%;
      left: 50%;
    }

    ${StyledButtonContent} {
      opacity: ${ifProp('submitting', 0, 1)};
      transition: opacity 0.33s ease;
    }

    ${props.css || ''}
  `;

export default buttonStyle;
